(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  if (!reduce) {
    document.querySelectorAll('[data-murphy-hero][data-animate="true"]').forEach(function (el) {
      el.classList.add('is-animated');
    });
  }

  document.querySelectorAll('[data-murphy-go]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      var dest = link.getAttribute('data-murphy-go');
      var current = document.body.getAttribute('data-murphy-mode');
      if (!dest || dest === current) {
        if (dest === current) event.preventDefault();
        return;
      }
      if (reduce) return;
      event.preventDefault();
      root.setAttribute('data-leaving', dest);
      window.setTimeout(function () {
        window.location.href = link.href;
      }, 180);
    });
  });

  window.addEventListener('pageshow', function () {
    root.removeAttribute('data-leaving');
  });
})();
